// Func = limiting Scope for this file
(function(){

	const fullnav = document.querySelector('.nav-holder');
	const primaryNav = {
		navToggle: document.querySelector('.nav-toggle'),
		doToggle: function(e) {
			e.preventDefault();
			this.navToggle.classList.toggle('expanded');
			fullnav.classList.toggle('expanded');
		}
	};
	if(fullnav) {
		primaryNav.navToggle.addEventListener('click', function (e) {
			primaryNav.doToggle(e);
		});
	}

	//tabs sections
	const tabLinks = document.querySelectorAll('ul.js-tabs-menu li a');

	for (let i = 0; i < tabLinks.length; i++) {
		tabLinks[i].onclick = function() {
			let target = this.getAttribute('href').replace('#', '');
			let sections = document.querySelectorAll('div.tab-content');
			for(let j=0; j < sections.length; j++) {
				sections[j].style.display = 'none';
			}
			document.getElementById(target).style.display = 'block';
			for(let k=0; k < tabLinks.length; k++) {
				tabLinks[k].removeAttribute('class');
			}
			this.setAttribute('class', 'active');
			return false;
		}
	}

	//animations below
	setTimeout(function(){
        if(document.getElementById('home')){
            document.getElementsByClassName('top-content__headline')[0].classList.add('appear');
        }
    }, 1000);

    const animateHTML = function () {
        let elems,
            windowHeight;
        let init = function () {
            elems = document.getElementsByClassName('hide-object');
            windowHeight = window.innerHeight;
            addEventHandlers();
        };
        let addEventHandlers = function () {
            window.addEventListener('scroll', checkPosition);
            window.addEventListener('resize', init);
        };
        let checkPosition = function () {
            for (let i = 0; i < elems.length; i++) {
                let posFromTop = elems[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight <= 0) {
                    elems[i].className = elems[i].className.replace('hide-object', 'show-object')
                }
            }
        };
        return {
            init: init
        }
    };
    animateHTML().init();

//    let animateText = document.getElementsByClassName('text-animate-js');
//    animateText.split("");
//    let i = 0, length = animateText.length;
//    for (i; i < length; i++) {
//        text.innerHTML += '<span class="each-letter">' + animateText[i] + '</span>';
//    }

    //end animations
	//remove atributes ada
	$('#third-nav').removeAttr('aria-label');
	$('#primary-nav').removeAttr('aria-label');
}());